import { lazy } from 'react'
import { hot } from 'react-hot-loader'

const exportable = {}

if (!module.hot) {
  exportable.Homeowner = lazy(() =>
    import('src/features/homeowners/Routes' /* webpackChunkName: "homeowner" */)
  )
  exportable.Buyer = lazy(() =>
    import('src/features/buyers/Routes' /* webpackChunkName: "buyer" */)
  )
  exportable.Preview = lazy(() =>
    import(
      'src/features/preview/home/Routes' /* webpackChunkName: "previewHome" */
    )
  )
  exportable.ZipCodeModal = lazy(() =>
    import(
      'src/Components/buyers/Global/ZipCodeModal' /* webpackChunkName: "ZipCodeModal" */
    )
  )
  exportable.Styleguide = lazy(() =>
    import('src/styleguide/Routes' /* webpackChunkName: "styleguide" */)
  )
} else {
  exportable.Homeowner = require('src/features/homeowners/Routes').default
  exportable.Buyer = require('src/features/buyers/Routes').default
  exportable.Preview = require('src/features/preview/home/Routes').default
  exportable.ZipCodeModal = require('src/Components/buyers/Global/ZipCodeModal').default
  exportable.Styleguide = require('src/styleguide/Routes').default
}

export default hot(module)(exportable)
